import { useTranslation } from 'react-i18next';
import { logo } from '@shared/assets';
import logoOnLight from '@shared/assets/icons/logo-dark.svg';
import { landingHref } from '@shared/i18n/lib/landing-href';
import { cn } from '@shared/lib/utils';

type AuthLogoTone = 'on-dark' | 'theme';

type AuthLogoLinkProps = {
  className?: string;
  /**
   * on-dark — светлый знак для тёмной подложки (логин, маркетинг).
   * theme — тёмный знак на светлой теме и светлый на .dark.
   */
  tone?: AuthLogoTone;
};

export function AuthLogoLink({ className = 'h-10', tone = 'on-dark' }: AuthLogoLinkProps) {
  const { i18n } = useTranslation();

  return (
    <a
      href={landingHref(i18n.language)}
      className="inline-flex rounded-sm transition-opacity hover:opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
      aria-label="Paygatex"
    >
      {tone === 'theme' ? (
        <>
          <img src={logoOnLight} alt="" className={cn(className, 'w-auto dark:hidden')} />
          <img src={logo} alt="" className={cn(className, 'hidden w-auto dark:block')} />
        </>
      ) : (
        <img src={logo} alt="" className={className} />
      )}
    </a>
  );
}
